import React, { Fragment, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { BaseRoutes } from "routes";
import "firebase/firestore";
import { ContextProvider } from "shared";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import ErrorBoundary from "ErrorrBoundary";
import { constants, selectedStripeKey } from "common";
import { CountryCodeProvider } from "context/countryCode";
function App() {
  // AWIN: Capture awc affiliate click ID from URL and store in cookie
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const awc = params.get("awc");
    if (awc) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      const secureFlag = isLocalhost ? "" : "; secure";
      document.cookie = `awc=${awc}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secureFlag}`;
    }
  }, []);

  const stripePromise = loadStripe(selectedStripeKey);
  const options = {
    mode: "payment",
    amount: 1099,
    currency: "usd",
  };

  const renderLoadingModal = () => {
    return (
      <Modal
        size="sm"
        show={false}
        centered
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Body>
          <Spinner color="grey" animation="grow" />
          <span>Loading</span>
        </Modal.Body>
      </Modal>
    );
  };
  return (
      <Elements stripe={stripePromise} options={options}>
        <ErrorBoundary>
          <ContextProvider>
            <CountryCodeProvider>
            <Router>
              <Fragment>
                {process.env.REACT_APP_ENV_BANNER && (
                  <div
                    style={{
                      position: "fixed",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      zIndex: 2147483647,
                      background: "#b45309",
                      color: "#fff",
                      textAlign: "center",
                      fontSize: 13,
                      fontWeight: 600,
                      padding: "6px 12px",
                      letterSpacing: 0.3,
                      boxShadow: "0 -2px 8px rgba(0,0,0,0.25)",
                    }}
                  >
                    {process.env.REACT_APP_ENV_BANNER}
                  </div>
                )}
                <BaseRoutes />
              </Fragment>
            </Router>

            {renderLoadingModal()}
            </CountryCodeProvider>
          </ContextProvider>
        </ErrorBoundary>
      </Elements>
  );
}

export default App;
